import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { Box, Button, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import GroupIcon from '@mui/icons-material/Group';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  },
  buttonRoot: {
    fontWeight: 'normal',
    textTransform: 'none',
    color: '#546E7A',

  }
}));

function Role({ role }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          mx={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="#546E7A"
        >
          <GroupIcon />
        </Box>
        <Box
          mx={1}
          color="#546E7A"
        >
          {
            role === 'Admin' || role === 'Manager' || role === 'Manager Of Users' ? (
              <Button
                className={classes.buttonRoot}
                onClick={() => history.push('/admin/users')}
              >
                {role}
              </Button>

            ) : (
              <Typography
                fontSize="14"
                variant="body2"
                cursor="pointer"
              >
                {role}
              </Typography>
            )

          }

        </Box>

      </Box>

    </>
  );
}

Role.propTypes = {
  role: PropTypes.string,
};

export default Role;
